import * as React from "react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import { useEffect } from "react";
import { BASE_URL, Role } from "../../Constants";
import { Select, Switch } from "antd";
const TurnServersForm = () => {
  const defaultEntity = {
    name: "",
    serverUrl: "",
    active: true,
  };

  const navigate = useNavigate();
  let { id } = useParams();
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [server, setServers] = useState(defaultEntity);
  const [isLoading, setIsLoading] = useState(false);

  const onValueChange = (e) => {
    const { name, value } = e.target;

    setServers({ ...server, [name]: value });
  };
  const onCancelClick = () => {
    navigate("/turnServers");
  };
  const fetchData = async () => {
    let res = await axios.get(`${BASE_URL}/TurnServer/${id}`);
    setServers(res.data);
  };
  useEffect(() => {
    if (id !== "new") {
      fetchData();
    }
  }, [id]);
  const onSubmit = async (e) => {
    e.preventDefault();
    const form = e.target;
    setIsSubmitted(true);

    if (form.checkValidity()) {
      setIsLoading(true); // Start loading

      try {
        if (id && id !== "new") {
          if (!server.id) server.id = id;
          console.log(server);
          let res = await axios.put(`${BASE_URL}/TurnServer`, server);
          if (res.data.id != 400) {
            toast.success("TurnServer updated successfully!");
            navigate(`/turnServers/${id}`);
          } else toast.error("Email already exist!");
        } else {
          const res = await axios.post(`${BASE_URL}/TurnServer`, server);
          if (res.data !== 400) {
            toast.success("TurnServer added successfully!");
            navigate(`/turnServers/${res.data}`);
          }
        }
      } catch (err) {
        if (err.response?.status === 400) toast.error(err.response.data);
        else
          toast.error("An error occurred while creating/updating TurnServer!");
      } finally {
        setIsLoading(false); // Reset loading
      }
    }
  };
  const handleChange = (value, option, targetName) => {
    setServers((pre) => ({ ...pre, [targetName]: value }));
  };
  return (
    <div className="px-7 space-y-2 py-5 bg-zinc-800 text-white w-full h-screen">
      <h2
        onClick={onCancelClick}
        className="text-ActiveUsers cursor-pointer text-md text-orange-600 font-semibold"
      >
        Turn Servers
        <span className="text-white">
          / {id === "new" ? "New" : "Update"} Server
        </span>
      </h2>
      <form noValidate onSubmit={onSubmit} className="">
        <div className="flex">
          <div className="grid grid-cols-2 lg:w-3/5 items-center gap-4 mt-2">
            <div className=" ">
              <p className="text-sm font-medium">Name</p>
              <input
                type="text"
                name="name"
                value={server?.name}
                required
                onChange={onValueChange}
                placeholder="Name"
                className="block mt-2 w-full px-2 h-9 border placeholder:text-xsm placeholder:text-gray-300 max-w-lg bg-neutral-900 rounded-md border-gray-600 shadow-sm focus:border-sky-500 focus:ring-sky-500  sm:text-sm"
              />
              {isSubmitted && !server?.name && (
                <p className="text-red-700 mt-1 text-xs font-semibold">
                  This field is required
                </p>
              )}
            </div>
            <div className=" ">
              <p className="text-sm font-medium">Server URL</p>
              <input
                type="text"
                name="serverUrl"
                value={server?.serverUrl}
                required
                onChange={onValueChange}
                placeholder="Server URL"
                className="block mt-2 w-full px-2 h-9 border placeholder:text-xsm placeholder:text-gray-300 max-w-lg bg-neutral-900 rounded-md border-gray-600 shadow-sm focus:border-sky-500 focus:ring-sky-500  sm:text-sm"
              />
              {isSubmitted && !server?.serverUrl && (
                <p className="text-red-700 mt-1 text-xs font-semibold">
                  This field is required
                </p>
              )}
            </div>
            <div className=" ">
              <p className="text-sm font-medium">Username</p>
              <input
                type="text"
                name="userName"
                value={server?.userName}
                required
                onChange={onValueChange}
                placeholder="Username"
                className="block mt-2 w-full px-2 h-9 border placeholder:text-xsm placeholder:text-gray-300 max-w-lg bg-neutral-900 rounded-md border-gray-600 shadow-sm focus:border-sky-500 focus:ring-sky-500  sm:text-sm"
              />
              {isSubmitted && !server?.username && (
                <p className="text-red-700 mt-1 text-xs font-semibold">
                  This field is required
                </p>
              )}
            </div>
            <div className=" ">
              <p className="text-sm font-medium">Token</p>
              <input
                type="password"
                name="token"
                value={server?.token}
                required
                onChange={onValueChange}
                placeholder="Token"
                className="block mt-2 w-full px-2 h-9 border placeholder:text-xsm placeholder:text-gray-300 max-w-lg bg-neutral-900 rounded-md border-gray-600 shadow-sm focus:border-sky-500 focus:ring-sky-500  sm:text-sm"
              />
              {isSubmitted && !server?.token && (
                <p className="text-red-700 mt-1 text-xs font-semibold">
                  This field is required
                </p>
              )}
            </div>
            <div className=" ">
              <p className="text-sm font-medium">Password</p>
              <input
                type="password"
                name="password"
                value={server?.password}
                required
                onChange={onValueChange}
                placeholder="Password"
                className="block mt-2 w-full px-2 h-9 border placeholder:text-xsm placeholder:text-gray-300 max-w-lg bg-neutral-900 rounded-md border-gray-600 shadow-sm focus:border-sky-500 focus:ring-sky-500  sm:text-sm"
              />
              {isSubmitted && !server?.password && (
                <p className="text-red-700 mt-1 text-xs font-semibold">
                  This field is required
                </p>
              )}
            </div>
          </div>
        </div>
        <div className="flex justify-end w-2/3 items-end space-x-2 mt-4">
          <button
            type="button"
            className="border-orange-700 border hover:border-orange-800 rounded-md text-white font-semibold px-4 py-2 ml-2"
            onClick={onCancelClick}
            disabled={isLoading}
          >
            Cancel
          </button>
          <button
            type="submit"
            className="bg-orange-700 hover:bg-orange-800 cursor-pointer disabled:cursor-not-allowed rounded-md text-white font-semibold px-4 py-2 ml-2"
            // onClick={onSubmit}
            disabled={isLoading}
          >
            {id === "new" ? "Create" : "Update"}
          </button>
        </div>
      </form>

      {isLoading && (
        <div
          role="status"
          className="absolute top-0 left-0 flex w-full h-full bg-slate-950 bg-opacity-50 justify-center items-center"
        >
          <svg
            aria-hidden="true"
            class="w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
            viewBox="0 0 100 101"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
              fill="currentColor"
            />
            <path
              d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
              fill="currentFill"
            />
          </svg>
          <span class="sr-only">Loading...</span>
        </div>
      )}
    </div>
  );
};

export default TurnServersForm;
